import {
  useCallback, useEffect, useState, useRef,
} from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import devicesApi from '@api/devicesApi';

function useHomeBusinessType() {

  const history = useHistory();
  const timerLopping = useRef();
  const timeoutRef = useRef();
  // const initPagination = useRef({ current: 1, pageSize: 100 });

  const abortC = new AbortController();
  const { signal } = abortC;
  const limit = 1000;
  const skip = 0;

  const [loading, setLoading] = useState(true);
  const [loadingBusiness, setLoadingBusiness] = useState(true);
  const [businessType, setBusinessType] = useState([]);
  const [businessData, setBusinessData] = useState([]);
  const [search, setSearch] = useState('');
  const [sorter, setSorter] = useState(false);

  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const createBusinessType = useCallback( // Go to create
    () => {

      history.push('/dispositivos/negocio/crear-negocio');

    },
    [history],
  );

  const readBusinessType = useCallback(async () => {

    if (timerLopping.current) clearTimeout(timerLopping.current);

    setLoading(true);

    await devicesApi.getAllBusinessType({ signal, skip, limit })
      .then(async (business) => {

        const newBusiness = await Promise.all(business.map(async (obj) => {

          const item = {
            id: obj.id,
            title: obj.name,
            description: obj.description,
            total_conecy: obj.total_conecy,
            logo_full_url: obj.logo_full_url,
            total_general: obj.total_general,
            total_general_clients: obj.total_general_clients,
            type: obj.type,
            businessTypeInfo: obj.businessTypeInfo,
          };
          return item;

        }));

        setLoading(false);
        setLoadingBusiness(false);
        setBusinessData(newBusiness);
        setBusinessType(newBusiness);

      }).catch((resError) => {

        if (signal.aborted) return;
        const { fem } = resError;
        // eslint-disable-next-line no-console
        console.log('fem ', fem);
        setLoading(false);

      });

  });

  const goToDeviceBusinessType = useCallback((item) => {

    if (item.type === 'Retail') {

      history.push(`/tablero-devices/${item.id}`);

} else {

      history.push(`/tablero-comunidades/${item.id}`);

}

  });

  const onSearch = useCallback(
    ({ target: { value } }) => {

      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setLoading(false);
      timeoutRef.current = setTimeout(() => setSearch(value), 800);

    },
    // eslint-disable-next-line
    []
  );

  const handleChange = useCallback(
    (pagination, filter) => {

      setLoadingBusiness(true);
      if (timerLopping.current) clearTimeout(timerLopping.current);
      setBusinessType([]);

      try {

        let businessTemp = ((search && search !== '') ? (businessData.filter((item) => item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0)) : businessData);

        businessTemp = businessTemp.sort((x, y) => {

          if (sorter ? (x.title < y.title) : (x.title > y.title)) {

            return -1;

          }

          if (sorter ? (x.title > y.title) : (x.title < y.title)) {

            return 1;

          }

          return 0;

        });

        setTimeout(() => {

          setBusinessType(businessTemp);
          setLoadingBusiness(false);

        }, 500);

      } catch (error) {

        setLoadingBusiness(false);
        console.log('error: ', error);

      }

    },
    [search, sorter],
  );

  const changeSort = () => {

    setSorter(!sorter);

  };

  useEffect(
    () => {

      if (businessData.length > 0) {

         handleChange();

}

},
    [search, sorter],
  );

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
    // eslint-disable-next-line
    setIsCreate(!!(currentUserRole === 'Superadmin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();
    readBusinessType();
    const interval = setInterval(() => {

      readBusinessType();

    }, 120000);
    return () => clearInterval(interval);

  }, []);

  return {
    createBusinessType,
    handleChange,
    loading,
    loadingBusiness,
    businessType,
    goToDeviceBusinessType,
    onSearch,
    changeSort,
    sorter,
    isCreate,
  };

}

export default useHomeBusinessType;
